import { updates } from "@/mocks/animeData";

function Updates() {
  return (
    <section id="updates" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="text-xs font-semibold tracking-widest text-accent-600 uppercase">
              Updates
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">
              追更动态，片单持续更新
            </h2>
            <p className="mt-2 max-w-xl text-sm md:text-base text-foreground-700">
              新片单、新名场面、新专题，编辑部的最新动态都在这里。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {updates.map((u) => (
            <article
              key={u.id}
              className="flex flex-col rounded-lg bg-background-50 border border-background-200/70 p-5 hover:border-accent-200 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-700">
                  {u.tag}
                </span>
                <span className="text-xs text-foreground-600">{u.date}</span>
              </div>
              <h3 className="mt-3 font-heading text-lg leading-snug text-foreground-950">
                {u.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">
                {u.text}
              </p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3">
                <span className="text-xs text-foreground-600">
                  阅读约 {u.readTime}
                </span>
                <a
                  href="#contact"
                  className="inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors"
                >
                  查看更多
                  <i className="ri-arrow-right-line text-sm"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Updates;